import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-6" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "persistTableName",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_DatasetScheduler = _resolveComponent("DatasetScheduler")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.dataset.isPersistedHDFS,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataset.isPersistedHDFS = $event)),
          class: "p-mr-2",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('touched')))
        }, null, 8, ["modelValue"]),
        _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isPersistedHDFS')), 1)
      ]),
      _: 1
    }),
    (_ctx.dataset.dsTypeCd != 'Flat')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3" }, {
            start: _withCtx(() => [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.dataset.isPersisted,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataset.isPersisted = $event)),
                disabled: _ctx.disablePersist,
                class: "p-mr-2",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isPersisted')), 1)
            ]),
            _: 1
          }),
          (_ctx.dataset.isPersisted)
            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                content: _withCtx(() => [
                  _createVNode("form", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("span", _hoisted_4, [
                        _createVNode(_component_InputText, {
                          id: "persistTableName",
                          class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.persistTableName.$invalid && _ctx.v$.dataset.persistTableName.$dirty
                                }],
                          type: "text",
                          modelValue: _ctx.dataset.persistTableName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataset.persistTableName = $event)),
                          onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.dataset.persistTableName.$touch())),
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue", "class"]),
                        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.datasetManagement.persistTableName')) + " *", 1)
                      ]),
                      _createVNode(_component_KnValidationMessages, {
                        class: "p-mt-1",
                        vComp: _ctx.v$.dataset.persistTableName,
                        additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.persistTableName') }
                      }, null, 8, ["vComp", "additionalTranslateParams"])
                    ])
                  ]),
                  (_ctx.dataset.isPersisted)
                    ? (_openBlock(), _createBlock(_component_Toolbar, {
                        key: 0,
                        class: "kn-toolbar kn-toolbar--default p-mt-3"
                      }, {
                        start: _withCtx(() => [
                          _createVNode(_component_InputSwitch, {
                            modelValue: _ctx.dataset.isScheduled,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataset.isScheduled = $event)),
                            class: "p-mr-2",
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched')))
                          }, null, 8, ["modelValue"]),
                          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isScheduled')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.dataset.isPersisted && _ctx.dataset.isScheduled)
                    ? (_openBlock(), _createBlock(_component_DatasetScheduler, {
                        key: 1,
                        selectedDataset: _ctx.dataset,
                        schedulingData: _ctx.schedulingData
                      }, null, 8, ["selectedDataset", "schedulingData"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}